import { apiClient } from './client';

export const authApi = {
    login: (credentials) => apiClient.post('/auth/login', credentials),
    signup: (userData) => apiClient.post('/auth/signup', userData),
    verifyToken: () => apiClient.get('/auth/verify'),
};
